export interface IFormValues {
    nationalCode: string
    phoneNumber: string
    serialCode: string
    nationalCardPhoto: File | null
}

export const initialValues: IFormValues = {
    nationalCode: '',
    phoneNumber: '',
    serialCode: '',
    nationalCardPhoto: null,
}

export interface IState {
    selectedFile: File | null
    isModalOpen: boolean
    tempFile: File | null
}

export const initialState: IState = {
    selectedFile: null,
    isModalOpen: false,
    tempFile: null,
}

export interface IAction {
    type: 'SET_SELECTED_FILE' | 'SET_MODAL_OPEN' | 'SET_TEMP_FILE'
    payload?: any
}
